// GuildBattleList.js
import React from 'react';

const GuildBattleList = ({ firstRoundResults, secondRoundResults, allGuilds }) => {
  console.log("All guild names provided to GuildBattleList:", allGuilds);
  // 1回戦と2回戦の結果をマップに格納
  const firstRoundMap = new Map();
  const secondRoundMap = new Map();

  firstRoundResults.forEach(match => {
    firstRoundMap.set(match.guildName, match.opponentGuildName);
    firstRoundMap.set(match.opponentGuildName, match.guildName);
  });

  secondRoundResults.forEach(match => {
    secondRoundMap.set(match.guildName, match.opponentGuildName);
    secondRoundMap.set(match.opponentGuildName, match.guildName);
  });

  // 3回戦の対戦相手を予想する関数
  const predictThirdRoundOpponents = () => {
    const predictions = {};

    allGuilds.forEach(guild => {
      const guildName = guild.name;
      // 2回戦で対戦したギルドの1回戦での対戦相手を取得
      const secondRoundOpponent = secondRoundMap.get(guildName);
      if (!secondRoundOpponent) {
        predictions[guildName] = '不明';
        return;
      }

      // 2回戦の対戦相手の1回戦の対戦相手を取得
      const firstRoundOpponentOfSecond = firstRoundMap.get(secondRoundOpponent);
      if (!firstRoundOpponentOfSecond) {
        predictions[guildName] = `${secondRoundOpponent}の1戦目の対戦相手の2戦目の対戦相手`;
        return;
      }

      // その1回戦の対戦相手の2回戦の対戦相手が3回戦の対戦相手
      const thirdRoundOpponent = secondRoundMap.get(firstRoundOpponentOfSecond);
      if (thirdRoundOpponent) {
        predictions[guildName] = thirdRoundOpponent;
      } else {
        predictions[guildName] = `${firstRoundOpponentOfSecond}の2戦目の対戦相手`;
      }
    });

    return predictions;
  };

  // 3回戦の予想結果を取得
  const thirdRoundPredictions = predictThirdRoundOpponents();

  // スタイル定義
  const styles = {
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '10px',
    },
    th: {
      border: '1px solid #ddd',
      padding: '8px',
      background: '#f2f2f2',
      fontWeight: 'bold',
    },
    td: {
      border: '1px solid #ddd',
      padding: '3px',
      textAlign: 'center',
      fontSize: '13px',
    },
    thirdRound: (opponent) => ({
      backgroundColor: opponent === '不明' ? '#d3d3d3' :
        opponent.includes('の対戦相手') ? '#ffff99' : // 薄い黄色に設定
          '#90ee90', // それ以外は緑
      fontSize: '13px',
    }),
    row: (rank) => ({
      backgroundColor:
        rank >= 1 && rank <= 20 ? '#e6f7ff' : // 1~20位: 薄い青
        rank >= 21 && rank <= 50 ? '#f9fbe7' : // 21~50位: 薄い黄緑
        'transparent',
    })
  };

  return (
    <div>
      <h2>This week's GuildWar information</h2>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}></th>
            <th style={styles.th}>GuildName</th>
            <th style={styles.th}>1st</th>
            <th style={styles.th}>2nd</th>
            <th style={styles.th}>3rd</th>
          </tr>
        </thead>
        <tbody>
          {Array.from(allGuilds)
            .sort((a, b) => a.lastGuildWarRank - b.lastGuildWarRank)
            .map((guild) => {
              const firstRoundOpponent = firstRoundMap.get(guild.name) || '---';
              const secondRoundOpponent = secondRoundMap.get(guild.name) || '---';
              const thirdRoundOpponent = thirdRoundPredictions[guild.name] || '不明';

              return (
                <tr key={guild.name} style={styles.row(guild.lastGuildWarRank)}>
                  <td style={styles.td}>{guild.lastGuildWarRank}</td>
                  <td style={styles.td}>{guild.name}</td>
                  <td style={styles.td}>{firstRoundOpponent}</td>
                  <td style={styles.td}>{secondRoundOpponent}</td>
                  <td style={styles.thirdRound(thirdRoundOpponent)}>{thirdRoundOpponent}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default GuildBattleList;
